import { render, staticRenderFns } from "./LogoutPmse.vue?vue&type=template&id=1a4b247f"
import script from "./LogoutPmse.vue?vue&type=script&lang=js"
export * from "./LogoutPmse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports